import styled from 'styled-components'
import MiniSwitch from '../../../formUtils/MiniSwitch'
import { useState } from 'react'
import { encodeAddPermissions, encodeRemovePermissions } from 'src/utils/permissions'
import { CLIENT_SAFE } from 'src/constants/networks'
import { shortenAddress } from 'src/utils/web3-utils'

const AddPermissionsGeneric = ({ setStartChanges, setEndChanges, encodedChanges, chainId, environmentAuthorizer }) => {
  const [editedProps, setEditedProps] = useState<any>(null)

  const handleChanges = () => {
    if (!Array.isArray(encodedChanges) || encodedChanges.length === 0) {
      console.error('No encoded changes')
      return
    }
    setEditedProps(!editedProps)
    const safeClient = CLIENT_SAFE[chainId]

    const FUNCTION_SELECTORS = {
      '0x0fe105e8': 'setTimeLock',
      '0xd3feb602': 'setDefaultTokenThreshold',
      '0x90333ba8': 'setDefaultVolumeLimit',
    }

    const startPermissions = []
    const endPermissions = []

    for (const change of encodedChanges) {
      const task = Object.keys(change)[0]
      const calldataArray = change[task]

      for (const calldata of calldataArray) {
        const selector = calldata.slice(0, 10)
        const functionName = FUNCTION_SELECTORS[selector]

        if (!functionName) {
          console.warn('Unknown function selector:', selector)
          continue
        }

        const encodeStartData = encodeAddPermissions(task, safeClient, selector)
        const encodeEndData = encodeRemovePermissions(task, safeClient, selector)

        startPermissions.push({ to: environmentAuthorizer, value: '0', data: encodeStartData })
        endPermissions.push({ to: environmentAuthorizer, value: '0', data: encodeEndData })
      }
    }

    setStartChanges(startPermissions)
    setEndChanges(endPermissions)
  }

  return (
    <Wrap>
      <Left>
        <Row>
          <Label>Add permissions for Timelocks</Label>
          <MiniSwitch ison={editedProps} onToggle={handleChanges} />
        </Row>
        {environmentAuthorizer && (
          <AuthorizerRow>
            <AuthorizerLabel>Authorizer</AuthorizerLabel>
            <AuthorizerAddress>{shortenAddress(environmentAuthorizer)}</AuthorizerAddress>
          </AuthorizerRow>
        )}
      </Left>
    </Wrap>
  )
}

export default AddPermissionsGeneric

const Wrap = styled.div`
  padding: 12px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.01);
`

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const Label = styled.span`
  color: #a0a0a0;
  font-size: 13px;
`

const AuthorizerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const AuthorizerLabel = styled.span`
  color: #555;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
`

const AuthorizerAddress = styled.span`
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 11px;
  color: #777;
`
